module.exports = new __parcel__URL__("embed-issue-navigator-skeleton.tpl.616c25ab.svg").toString();